import React from 'react'

import useStyles from './suggestion-reply.style'

import { useDispatch } from 'react-redux'

import { ATTEMPT_MESSAGE_SEND_WITH_LOCATION, ON_MESSAGE_SEND } from '@actions/types'

const SuggestionReply = (props) => {
  const classes = useStyles(props)

  const { disabled = false, index, messageGuid, messageId, onClick, pressed = false, suggestion } = props

  const { reply } = suggestion

  const { text, include_location: includeLocation } = reply

  const dispatch = useDispatch()

  const handleOnClick = (e) => {
    e.preventDefault()

    /* Belt-and-braces: the JSX `disabled` prop already blocks the
     * native click, but if the button receives a synthetic event from
     * a test or a touch double-fire, bail before dispatching. */
    if (disabled || pressed) return

    onClick(index)

    const message = {
      type: 'suggestion',
      text,
      location: null
    }

    if (includeLocation) {
      dispatch({
        type: ATTEMPT_MESSAGE_SEND_WITH_LOCATION,
        payload: {
          message,
          messageGuid,
          messageId
        }
      })
    } else {
      dispatch({ type: ON_MESSAGE_SEND, payload: { message, messageGuid, messageId } })
    }
  }

  const className = pressed
    ? `${classes.suggestion} ${classes.pressed}`
    : disabled
      ? `${classes.suggestion} ${classes.disabled}`
      : classes.suggestion

  return (
    <button
      aria-busy={pressed || undefined}
      className={className}
      data-pressed={pressed || undefined}
      data-testid='suggestion-reply'
      disabled={disabled}
      onClick={handleOnClick}
    >
      <span className={classes.text}>{text}</span>
      {pressed && <span
        aria-hidden='true'
        className={classes.spinner}
        data-testid='suggestion-reply-spinner'
      />}
    </button>
  )
}

export default SuggestionReply
